import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { ChapterOperations } from '../chapter-operations';
import type { ChapterParagraph } from '@/domains/proof-reading/types';

/**
 * 章节操作适配器
 * @description 将 useChapters 的方法适配为 ChapterOperations 接口
 */
@injectable()
export class ChapterOperationsAdapter implements ChapterOperations {
    private _getCurrentParagraph?: (paragraphIndex: string) => ChapterParagraph | null;
    private _updateParagraphContent?: (chapterId: string, paragraphIndex: string, newContent: string) => void;

    /**
     * 设置章节操作方法
     * @param getCurrentParagraph 获取段落方法
     * @param updateParagraphContent 更新段落方法
     */
    setChapterMethods(
        getCurrentParagraph: (paragraphIndex: string) => ChapterParagraph | null,
        updateParagraphContent: (chapterId: string, paragraphIndex: string, newContent: string) => void,
    ): void {
        this._getCurrentParagraph = getCurrentParagraph;
        this._updateParagraphContent = updateParagraphContent;
    }

    getCurrentParagraph(paragraphIndex: string): ChapterParagraph | null {
        if (!this._getCurrentParagraph) {
            throw new Error('ChapterOperationsAdapter 未初始化，请先调用 setChapterMethods');
        }
        return this._getCurrentParagraph(paragraphIndex);
    }

    updateParagraphContent(chapterId: string, paragraphIndex: string, newContent: string): void {
        if (!this._updateParagraphContent) {
            throw new Error('ChapterOperationsAdapter 未初始化，请先调用 setChapterMethods');
        }
        this._updateParagraphContent(chapterId, paragraphIndex, newContent);
    }
}
